import { memo, useRef } from 'react';
import FloatAnimation, { FloatAnimationVariant } from './FloatAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

// Cloud path used for both clip-path and visual rendering
const CLOUD_PATH =
  'M47.0684 38C59.2823 38 69.1836 47.9013 69.1836 60.1152C69.1836 60.5608 69.1695 61.0033 69.1436 61.4424H76.3457C85.6283 61.4424 93.1543 68.9674 93.1543 78.25C93.1541 87.5325 85.6282 95.0576 76.3457 95.0576H26.8076C17.5251 95.0576 10.0002 87.5325 10 78.25C10 69.5784 16.5669 62.4402 24.999 61.5381C24.9691 61.0676 24.9531 60.5932 24.9531 60.1152C24.9531 47.9012 34.8544 38 47.0684 38Z';

function PartlyCloudyNightIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="127"
      height="120"
      viewBox="0 0 127 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-partly-cloudy-night"
    >
      <g filter="url(#filter0_d_partly_cloudy_night)">
        <path
          d="M89.0078 25C85.2514 29.6384 83 35.5457 83 41.9795C83 56.8912 95.0883 68.9795 110 68.9795C110.332 68.9795 110.662 68.9709 110.991 68.959C106.041 75.0709 98.4777 78.9795 90 78.9795C75.0883 78.9795 63 66.8912 63 51.9795C63 37.4 74.5558 25.5221 89.0078 25Z"
          fill="#FFA51F"
        >
          <FloatAnimation
            variant={FloatAnimationVariant.MoonDrift}
            rotate
            rotateAmplitude={7}
            rotateDuration={6}
            rotateCenterX={87}
            rotateCenterY={52}
          />
        </path>
      </g>
      {/* Cloud group - foreignObject and path animate together */}
      <g>
        <FloatAnimation />
        {/* Backdrop blur effect using foreignObject with clip-path */}
        <foreignObject x="-10" y="18" width="123.154" height="97.0576">
          <div
            // @ts-expect-error xmlns is valid for foreignObject content
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              clipPath: 'url(#bgblur_partly_cloudy_night_clip)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        {/* Cloud overlay with semi-transparent fill */}
        <path d={CLOUD_PATH} fill="white" fillOpacity="0.7" />
      </g>
      <defs>
        <filter
          id="filter0_d_partly_cloudy_night"
          x="47"
          y="9"
          width="79.9912"
          height="85.9795"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        {/* Clip path for backdrop blur - offset to match foreignObject position */}
        <clipPath
          id="bgblur_partly_cloudy_night_clip"
          transform="translate(10 -18)"
        >
          <path d={CLOUD_PATH} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(PartlyCloudyNightIcon);
